export const ACCOUNTS_ROUTE = '/accounts';
export const PARTNER_INTEGRATIONS_ROUTE = '/partner-integrations';
export const CLIENT_METRICS_ROUTE = '/client-metrics';
export const INBOUND_CONNECTIONS_ROUTE = '/inbound-connections';

export const DEFAULT_ROUTE = ACCOUNTS_ROUTE;
